import { helmetJsonLdProp} from 'react-schemaorg';

export const getLDProduct = ({ id, name, image, price }) => {
  const priceEndDate = new Date();
  priceEndDate.setMonth(priceEndDate.getMonth() + 1);

  return helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"Product",
    "name": name,
    "description":`${name}  ⏩ — Купити в УКРАЇНИ з Польщі — з ALLEGRO pl ⚡ Авто, мото запчастини з Allegro, із Польщі ✅ Доставка - Київ, ...`,
    "image": image,
    "url": window.location.href,
    "sku": String(id),
    "offers":{
       "@type":"Offer",
       "url": window.location.href,
       "price": String(price),
       "priceCurrency":"UAH",
       "priceValidUntil":priceEndDate,
       "availability":"InStock"
    },
    "brand":{
       "@type":"Thing",
       "name":"Original"
    }
 })
}

export const getLDBreadcrumbsList = (itemsList = []) => {
  const LDList = itemsList.map((item, index) => ({
    "@type": "ListItem",
    "position": index,
    "name": item.name,
    "item": item.action
  }))

  return helmetJsonLdProp({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": LDList
  })
}

export const getLDOffersList = ({ products = [], totalCount, lowPrice, highPrice }) => {
  const LDProductsList = products.map((item) => ({
    "@type": "Offer",
    "url": `https://xpart.in.ua/products/${item.id}`,
    "image": ((item.images || [])[0] || {}).original,
  }))

  return helmetJsonLdProp({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Автозапчастини з Польщі",
    "brand": "Xpart",
    "offers": {
      "@type": "AggregateOffer",
      "mpn":" 3C9955711A",
      "description": "Автозапчасти из Польши",
      "lowPrice": String(lowPrice),
      "highPrice": String(highPrice),
      "priceCurrency": "UAH",
      "offerCount": totalCount,
      "offers": LDProductsList
    }
  })
}

export const getLDOrganization = () => (
  helmetJsonLdProp({
    "@context": "https://schema.org",
    "@type": "Organization",
    "url": "https://xpart.in.ua/",
    "address": [
      "80300, Львівська обл., м.Жовква",
    ],
    "contactPoint": {
       "@type": "ContactPoint",
       "telephone": "+380-937-89-58-77",
       "email": "xpartforparts@gmail.com",
       "image": "https://www.xpart.in.ua/logo.png",
       "sameAs": [
          "viber://chat?number=380937895877",
          "https://www.instagram.com/x_part_zp/",
          "https://t.me/celibrik"
        ]
    }
  })
)

export const getLDStore = () => (
  helmetJsonLdProp({
    "@context": "https://schema.org",
    "@type": "Store",
    "address": {
      "streetAddress": "вул. Дорошенка",
      "addressLocality": "Жовква",
      "postalCode": "80300",
      "addressCountry": "UA"
    },
    "name": "Xpart",
    "image": "https://www.xpart.in.ua/logo.png",
    "vatID": "https://xpart.in.ua",
    "telephone": "0 937 89 58 77",
    "url": "https://xpart.in.ua",
    "contactPoint": {
      "@type": "ContactPoint",
      "sameAs": [
        "viber://chat?number=380937895877",
        "https://www.instagram.com/x_part_zp/",
        "https://t.me/celibrik"
      ]
   }
  })
)

export const getLDWebSite = () => (
  helmetJsonLdProp({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Xpart",
    "url": window.location.href,
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://xpart.in.ua/products?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  })
)

export const getLDOfflineEvent = ({ name, description, firstItemImage }) => {
  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + 3);

  return helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"Event",
    "eventAttendanceMode":"OfflineEventAttendanceMode",
    "eventStatus":"https://schema.org/EventScheduled",
    "name": name,
    "description": description,
    "url": window.location.href,
    "startDate": new Date().toLocaleDateString(),
    "endDate": endDate.toLocaleDateString(),
    "image": firstItemImage,
    "performer":"Xpart",
    "location":{
        "@type":"Place",
        "name":"Xpart",
        "address":{
          "addressLocality":"Жовква",
          "addressRegion":"Львівська область",
          "streetAddress":"80300, Львівська обл., м.Жовква, вул.Дорошенка"
        }
    },
    "offers":{
      "@type":"Offer",
      "availability":"https://schema.org/InStock",
      "price": "155",
      "priceCurrency": "UAH",
      "url": "https://www.xpart.in.ua/logo.png",
      "validFrom": new Date().toLocaleDateString(),
    },
    "organizer":{
      "@type":"Organization",
      "name":"Xpart",
      "url":"https://xpart.in.ua"
    }
  })
}

export const getLDLocalBusiness = () => (
  helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"LocalBusiness",
    "name":"Контакти інтернет-магазину авто і мото запчастин XPART",
    "image": "https://www.xpart.in.ua/logo.png",
    "url": window.location.href,
    "telephone": "0 937 89 58 77",
    "priceRange": "UAH",
    "address":{
      "@type":"PostalAddress",
      "streetAddress":"Дорошенка",
      "addressLocality":"Жовква",
      "postalCode":"80300",
      "addressCountry":"UA"
    },
    "openingHoursSpecification":{
      "@type":"OpeningHoursSpecification",
      "dayOfWeek":[
         "Monday",
         "Tuesday",
         "Wednesday",
         "Thursday",
         "Friday",
         "Saturday",
         "Sunday"
      ],
      "opens":"00:00",
      "closes":"23:59"
    },
    "sameAs": [
      "viber://chat?number=380937895877",
      "https://www.instagram.com/x_part_zp/",
      "https://t.me/celibrik"
    ]
  })
)

export const getLDAutoparts = () => (
  helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"AutoPartsStore",
    "name":"XPART",
    "image": "https://www.xpart.in.ua/logo.png",
    "url": window.location.href,
    "telephone": "0 937 89 58 77",
    "priceRange":"UAH",
    "address":{
      "@type":"PostalAddress",
      "streetAddress":"Дорошенка",
      "addressLocality":"Жовква",
      "postalCode":"80300",
      "addressCountry":"UA"
    },
    "openingHoursSpecification":{
      "@type":"OpeningHoursSpecification",
      "dayOfWeek":[
         "Monday",
         "Tuesday",
         "Wednesday",
         "Thursday",
         "Friday",
         "Saturday",
         "Sunday"
      ],
      "opens":"00:00",
      "closes":"23:59"
    },
    "sameAs": [
      "viber://chat?number=380937895877",
      "https://www.instagram.com/x_part_zp/",
      "https://t.me/celibrik"
    ]
  })
)

export const getLDMainEntity = () => (
  helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"Product",
    "mainEntityOfPage":"https://www.xpart.in.ua",
    "name":"Xpart — Автозапчасти з Польщі в Україну.",
    "image":"https://www.xpart.in.ua/logo.png",
    "aggregateRating":{
      "@type":"AggregateRating",
      "ratingValue":5,
      "ratingCount":243,
      "worstRating":1,
      "bestRating":5
    }
  })
)

export const getLDOnlineEventAttendanceMode = () => {
  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + 3);

  return helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"Event",
    "eventAttendanceMode":"https://schema.org/OnlineEventAttendanceMode",
    "eventStatus":"https://schema.org/EventScheduled",
    "name":"✅ Доставка і оплата",
    "description":"Доставка з ALLEGRO.PL. Доставка запчастин із Польщі в Україну",
    "url": window.location.href,
    "startDate": new Date().toLocaleDateString(),
    "endDate":endDate.toLocaleDateString(),
    "image":"https://www.xpart.in.ua/logo.png",
    "performer":{
      "@type":"Person",
      "name":"XPART"
    },
    "location":{
      "@type":"Place",
      "name":"Xpart"
    },
    "offers":{
      "@type":"Offer",
      "availability":"https://schema.org/InStock",
      "price":100,
      "priceCurrency":"UAH",
      "url":"https://www.xpart.in.ua/logo.png",
      "validFrom": new Date().toLocaleDateString()
    }
 })
}

export const getLDArticle = ({ name, description, createdAt, updatedAt }) => (
  helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"Article",
    "datePublished":createdAt,
    "dateModified":updatedAt,
    "author":"✅ Xpart",
    "headline": name,
    "description": description,
    "publisher":{
       "@type":"Organization",
       "name":"Xpart",
       "logo":{
          "@type":"ImageObject",
          "url":"https://www.xpart.in.ua/logo.png"
       }
    }
 })
)

export const getLDImage = ({ image, createdAt, name }) => (
  helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"ImageObject",
    "author":"Xpart",
    "contentLocation":"80300, Львівська обл., м.Жовква, вул.Дорошенка",
    "contentUrl": image,
    "datePublished":createdAt,
    "description": name,
    "name":name
 })
)

export const getLDProductGroup = ({ id, name, image, recommendedProducts}) => {
  const variants = recommendedProducts.map((item) => ({
    "@type":"Product",
    "name":item.name,
    "image":(item.images[0] || {}).original,
    "description": item.name,
    "offers":{
      "@type":"Offer",
      "url":window.location.href,
      "price":item.price,
      "priceCurrency":"UAH",
      "itemCondition":"https://schema.org/NewCondition",
      "availability":"https://schema.org/InStock",
      "shippingDetails":{
        "@id":"#shipping_policy"
      },
      "hasMerchantReturnPolicy":{
        "@id":"#return_policy"
      }
    }
  }))

  return helmetJsonLdProp({
    "@context":"https://schema.org",
    "@type":"ProductGroup",
    "name":name,
    "image":image,
    "description":name,
    "brand":{
      "@type":"Brand",
      "name":"Original"
    },
    "productGroupID":String(id),
    "pattern":"manufacturer",
    "variesBy":[
      "https://schema.org/price"
    ],
    "hasVariant": variants
 })
}

export const getCommonLDScripts = () => ([
  getLDOrganization(),
  getLDLocalBusiness(),
  getLDStore(),
  getLDWebSite(),
  getLDAutoparts(),
  getLDMainEntity(),
  getLDOnlineEventAttendanceMode(),
])